// extracted by mini-css-extract-plugin
export var progressBar = "_kv-0";
export var progressBarInner = "_kv-1";